import { gql } from '@apollo/client';

export const getBusinessUserDetailsInfo = gql`
  query getBusinessUserDetailsInfo($id: ID!) {
    core {
      getUserDetails(userId: $id) {
        user {
          personId
          createdBy
          modifiedBy
          userRoles {
            role {
              id
              name
            }
          }
          id
          type
          userName
          normalizedUserName
          email
          normalizedEmail
          emailConfirmed
          firstName
          middleName
          lastName
          phoneNumber
          status
          access
          code
          createdOn
          modifiedOn
          accessFailedCount
          clauseEditRights
          concurrencyStamp
          groupPolicyEditRights
          lockoutEnabled
          lockoutEnd
          passwordHash
          phoneNumberConfirmed
          planCoverEditRights
          policyEndDateEditRights
          securityStamp
          twoFactorEnabled
          allowPolicyCancellation
          allowPolicyCorrection
          allowPolicyEndorsement
          allowTransactionModification
          editableChargesLines {
            createdBy
            createdOn
            id
            lineID
            modifiedBy
            modifiedOn
            userID
            line {
              abbreviation
              abbreviationArabic
              code
              createdBy
              createdOn
              id
              modifiedBy
              modifiedOn
              name
              nameArabic
              status
            }
          }
        }
        person {
          addresses {
            addressType
            createdBy
            createdOn
            id
            isPrimary
            modifiedBy
            modifiedOn
            personId
            status
            address {
              addressDetails
              addressDetailsArabic
              building
              city
              country
              street
              zone
            }
            country {
              code
              createdOn
              id
              modifiedOn
              title
            }
          }
          code
          personTitle {
            title
          }
          title
          dateOfBirth
        }
      }
    }
  }
`;

export const getEntityAuditTrailsQuery = gql`
  query getEntityAuditTrails($id: String!) {
    core {
      getEntityAuditTrails(id: $id) {
        createdBy
        createdOn
        entityId
        id
        modifiedBy
        message
        modifiedOn
        title
        type
      }
    }
  }
`;

export function getBusinessPartnersList() {
  return gql`
    query getBusinessPartnersList(
      $currentPage: Int!
      $currentPageSize: Int!
      $selectedBusinessUserID: String
    ) {
      SalesforceManagement {
        queries {
          getAssignedBPList(
            pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
            selectedBusinessUserID: $selectedBusinessUserID
          ) {
            paging {
              pageSize
              pageNumber
              totalCount
            }
            items {
              salesforceManagement_AssignedBP_Id
              businessPartner_Id
              businessPartner_PersonID {
                id
                views {
                  SalesforceManagement_all {
                    properties {
                      FullName
                    }
                  }
                }
              }
              salesforceManagement_AssignedBP_BusinessUserID {
                id
              }
              salesforceManagement_AssignedBP_BusinessPartnerID {
                id
              }
            }
          }
        }
      }
    }
  `;
}
